import React, { useState, useEffect } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import io from "socket.io-client";
import "./Navbar.css";
import { Badge, Divider, Grid, Menu, Typography, Stack, Box, Button } from "@mui/material";
import { FaAlignLeft } from "react-icons/fa";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BusinessIcon from '@mui/icons-material/Business';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import API from "../../utils/Axios.utils";
import useStyles from "../../assets/styles/SupMangComp.style";
import AccountPopover from "./AccountPopover";
import useAuth from "../../hooks/useAuth";

const Navbar = ({ toggleSidebar }) => {
  const classes = useStyles();
  const [showLogout, setShowLogout] = useState(false);
  const [notifyCountt, setNotifyCount] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notifyData, setNotifyData] = React.useState([]);
  const [socketResponse, setsocketResponse] = React.useState("");
  const [tenantInfo, setTenantInfo] = useState({
    organisationName: "",
    customerName: "",
  });

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const NotifyHandler = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const { token, userId: UserID, user } = useAuth();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getTenantInfo = async () => {
    try {
      const res = await API.get("/api/users/tenant-info", config);
      if (res.data) {
        setTenantInfo(res.data);
      }
    } catch (error) {
      console.log("Error fetching tenant info:", error);
    }
  };

  const getSupplier = async () => {
    try {
      const res = await API.get(
        `/api/users/supplier/notification/${UserID}`,
        config
      );

      const allNotifs = res.data.notifications || [];
      const unreadCount = allNotifs.filter(n => !n.isRead).length;

      setNotifyData(allNotifs);
      setNotifyCount(unreadCount);
    } catch (error) {
      console.log(error);
    }
  };

  const markAllAsRead = async () => {
    try {
      await API.put(`/api/users/supplier/notification/${UserID}`, {}, config);
      getSupplier();
    } catch (error) {
      console.log(error);
    }
  };

  const markOneAsRead = async (notificationId) => {
    try {
      await API.put(`/api/users/supplier/notification/${notificationId}`, {}, config);
      getSupplier();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSupplier();
    getTenantInfo();
  }, [socketResponse]);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_SERVER_SOCKET_URL, {
      path: "/socket.io",
    });

    socket.on("messageFromServer", (data) => {
      console.log("Message from server:", data);
    });

    socket.on("profileAddNotify", (data) => {
      console.log("profile_add:", data);
      setsocketResponse(data);
    });

    socket.on("jobAssignedNotify", (data) => {
      console.log("job_assigned:", data);
      setsocketResponse(data);
    });

    socket.on("status", (data) => {
      console.log("statuschanged:", data);
      setsocketResponse(data);
    });

    socket.on("notification", (data) => {
      console.log("Messages:", data);
      setsocketResponse(data);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const isReadNotif = async () => {
    try {
      await API.put(`/api/users/supplier/notification/${UserID}`, {}, config);
    } catch (error) {
      console.log(error);
    }
  };

  const Firstname = user?.first_name;

  const Lastname = user?.last_name;

  const name = Firstname + Lastname;

  return (
    <nav className="navbar_container">
      <Grid container className="navbar-container">
        <Grid
          item
          xl={9}
          lg={9}
          md={9}
          sm={6}
          xs={6}
          className="navbar-container-notification"
        >
          <button type="button" className="toggle-btn" onClick={toggleSidebar}>
            <FaAlignLeft />
          </button>

          {/* Professional Display for Organization and Customer Names */}
          <Stack direction="row" spacing={3} sx={{ ml: 3, alignItems: 'center' }}>
            {tenantInfo.organisationName && (
              <Box sx={{ display: 'flex', alignItems: 'center', color: '#1A1A2E' }}>
                <BusinessIcon sx={{ fontSize: 20, mr: 1, opacity: 0.8, color: '#2563EB' }} />
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', lineHeight: 1, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: '10px' }}>
                    Organisation
                  </Typography>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.2, whiteSpace: 'nowrap' }}>
                    {tenantInfo.organisationName}
                  </Typography>
                </Box>
              </Box>
            )}

            {tenantInfo.organisationName && tenantInfo.customerName && (
              <Divider orientation="vertical" flexItem sx={{ bgcolor: 'rgba(0,0,0,0.1)', height: 24, alignSelf: 'center' }} />
            )}

            {tenantInfo.customerName && (
              <Box sx={{ display: 'flex', alignItems: 'center', color: '#1A1A2E' }}>
                <CorporateFareIcon sx={{ fontSize: 20, mr: 1, opacity: 0.8, color: '#2563EB' }} />
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', lineHeight: 1, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: '10px', color: '#6B7280' }}>
                    Customer
                  </Typography>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.2, whiteSpace: 'nowrap' }}>
                    {tenantInfo.customerName}
                  </Typography>
                </Box>
              </Box>
            )}
          </Stack>
        </Grid>

        <Grid
          item
          xl={3}
          lg={3}
          md={3}
          sm={6}
          xs={6}
          className="navbar-container-user"
        >
          <div style={{ marginRight: "20px" }}>
            <button
              className="NavsecondNotifBtn"
              onClick={(e) => {
                NotifyHandler(e);
              }}
            >
              <Badge badgeContent={notifyCountt} color="error" max={99}>
                <NotificationsIcon
                  sx={{ fontSize: "25px", color: "#3E97FF" }}
                />
              </Badge>
            </button>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              sx={{
                "& .MuiPopover-paper": {
                  overflowX: "unset !important",
                  overflowY: "unset !important",
                },
              }}
            >
              {notifyData?.length === 0 ? (
                <div className="NavNoNotificationDiv">
                  <Grid container style={{ padding: "10px" }}>
                    <Grid item xs={12}>
                      <div
                        className="Navdes_text"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        No Notifications
                      </div>
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <div className={classes.scrollbar} style={{ maxHeight: '400px', overflowY: 'auto', width: '350px' }}>
                  <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Notifications</Typography>
                    <Button size="small" onClick={markAllAsRead} sx={{ fontSize: '12px' }}>Mark all as read</Button>
                  </Box>
                  {notifyData.map((list, i) => {
                    const now = new Date();
                    const createdDate = new Date(list.createdAt);
                    const timeDifferenceMs = now - createdDate;
                    const minutesDifference = Math.floor(timeDifferenceMs / (1000 * 60));
                    const hoursDifference = Math.floor(minutesDifference / 60);

                    let outputMessage = "";
                    if (minutesDifference < 60) {
                      outputMessage = `${minutesDifference} mins ago`;
                    } else if (hoursDifference < 24) {
                      outputMessage = `${hoursDifference} hours ago`;
                    } else {
                      const daysDifference = Math.floor(hoursDifference / 24);
                      outputMessage = `${daysDifference} days ago`;
                    }

                    return (
                      <div 
                        key={i} 
                        style={{ 
                          backgroundColor: list.isRead ? 'transparent' : '#f0f7ff',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s'
                        }}
                        onClick={() => !list.isRead && markOneAsRead(list.notification_id)}
                      >
                        <Grid container style={{ padding: "12px 16px" }}>
                          <Grid item xs={12}>
                            <Typography variant="body2" sx={{ fontWeight: list.isRead ? 400 : 600, color: '#333' }}>
                              {list.message}
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#888', mt: 0.5, display: 'block' }}>
                              {outputMessage}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Divider />
                      </div>
                    );
                  })}
                </div>
              )}
            </Menu>
          </div>

          {/* <AccountCircleOutlinedIcon className="navbar-user-avtar" /> */}

          {/* <div className="btn-container">
            <span
              className="navbar-userName"
              onClick={() => {
                setShowLogout(!showLogout);
              }}
            >
              {name ? name : "User"}
            </span>
          </div> */}
          <AccountPopover />
        </Grid>
      </Grid>
    </nav>
  );
};

export default Navbar;
